<template>
  <div class="cycle_rank" v-if="clazz">
    <clazz-show-header :clazz="clazz" />

    <div class="rank_container bgwhite mt15">
      <div class="header after_border">
        <div class="left">参与人数 {{ total }}</div>
        <rank-select v-model="rankCode" :clazz-type="clazz.clazz_type" @confirm="onConfirm"/>
        <!-- <div class="right" @click="onHelp">榜单说明</div> -->
      </div>

      <div v-if="rankCode" class="rank_list">
        <van-list
          v-model="loading"
          finished-text="没有更多了"
          :finished="finished"
          :immediate-check="true"
          @load="onLoad"
        >
          <rank-cell
            v-for="(item, index) in list"
            :key="index"
            :data="item"
            :rank-code="rankCode"
            :rank="index+1"
          />
        </van-list>
      </div>

    </div>

    <van-dialog v-model="show">
      积分说明
    </van-dialog>

  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { List, Dialog } from 'vant'
import ClazzShowHeader from '@/views/clazz/components/ClazzShowHeader'
import RankSelect from '@/views/clazz/components/RankSelect'
import RankCell from '@/views/clazz/components/RankCell'
import { clazzSimpleInfo, clazzTotalRank } from '@/api/clazz'

export default {
  name: 'ClazzRank',
  components: {
    [List.name]: List,
    [Dialog.name]: Dialog,
    ClazzShowHeader,
    RankSelect,
    RankCell
  },
  filters: {
    rankLabel (value) {
      if (value === 'day') {
        return '天数'
      } else if (value === 'distance') {
        return '距离（km）'
      } else if (value === 'duration') {
        return '时长'
      } else if (value === 'pace') {
        return '配速'
      } else if (value === 'num') {
        return '记录数'
      }
      return ''
    }
  },
  data () {
    return {
      rankCode: '',
      clazzId: undefined,
      clazz: null,
      show: false,
      total: '',
      list: [],
      loading: false,
      finished: false,
      listQuery: {
        page: 0,
        size: 8
      }
    }
  },
  computed: {
    ...mapGetters([
      'userprofile'
    ])
  },
  created () {
    this.clazzId = this.$route.params.clazz_id || ''
    this.getClazzInfo()
    this.getMyRank()
  },
  methods: {
    async getClazzInfo () {
      let response = await clazzSimpleInfo(this.clazzId)
      this.clazz = response.data
    },
    onHelp () {
      this.show = true
    },
    getRankList () {
      this.getTotalRank()
    },
    onLoad () {
      this.listQuery.page += 1
      this.getRankList()
    },
    async getTotalRank () {
      this.loading = true
      let response = await clazzTotalRank(this.clazzId, { rank: this.rankCode })
      this.loading = false
      this.list = this.list.concat(response.data.results)
      this.total = response.data.count
      this.checkFinished(response.data.count)
    },
    checkFinished (total) {
      this.finished = this.list.length >= total
    },
    onConfirm (code) {
      this.listQuery.page = 0
      this.finished = false
      this.list = []
      this.getRankList()
    }
  }
}
</script>

<style scoped lang="scss">
.cycle_rank {
  background-color: #f8f8f8;
  .rank_container {
    .header {
      padding: 30px 20px 30px 0;
      display: flex;
      align-items: center;
      justify-content: space-between;
      .left {
        color: #b1b1b1;
        font-size: 26px;
        padding-left: 20px;
      }
      .right {
        color: #b1b1b1;
        font-size: 26px;
        border: 2px solid #f1f1f1;
        padding: 3px 12px;
        border-right-width: 0;
        border-top-left-radius: 20px;
        border-bottom-left-radius: 20px;
      }
    }
  }
}
</style>
